export default "__VITE_ASSET__67049ba8__"